<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {getInstance} from '../../../../services/animation';
  import editorInstance from '../../../../lib/editor/editor';
  import editorStore from '../../../../lib/editor/editor.store';
  import FontEditor from '../FontEditor/FontEditor.svelte';

  export let element: HTMLElement;
  let elementText: string;
  export let elText: string;
  let open = false;

  function changedValue() {
    element.removeAttribute('data-amelement');
    const dynamicElement = element.querySelector('.dynamic');
    if (dynamicElement) dynamicElement.innerHTML = elText;
  }

  function removeElement() {
    editorInstance.history.addHistory('Delete component');
    element.remove();
    getInstance().templateLoader.textLoader.identifyTextElements();
    editorStore.setActiveComponent(null);
  }

  function getElement() {
    return element.querySelector('.dynamic') as HTMLElement;
  }

  function toggle() {
    open = !open;
  }

  function onMouseOver() {
    editorInstance.ui.highlight(element);
  }

  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  $: angleIcon = open ? 'fa-angle-up' : 'fa-angle-down';

  const unsubscribe = editorStore.subscribe(store => (open = store.activeComponent === element));

  onMount(() => (elText = element.innerText));
  onDestroy(unsubscribe);
</script>

<div
  class="{open ? 'bg-white' : ''} block rounded-xl border border-zinc-300"
  on:mouseover={onMouseOver}
  on:focus={onMouseOver}
  on:mouseleave={onMouseLeave}
>
  <div
    class="flex w-full items-center bg-white px-4 pt-4 {open
      ? 'mb-4 rounded-tl-xl rounded-tr-xl'
      : 'rounded-xl px-4 py-3'} "
  >
    <button class="nolineheight mr-3 block cursor-pointer" on:click={toggle} on:keypress={toggle}>
      <i class="fa {angleIcon}" />
    </button>
    <div class="relative mr-2 flex-grow rounded-xl border bg-white p-1">
      <input class="block w-full bg-white px-2 outline-transparent" bind:value={elText} on:input={changedValue} />
      <!-- <i class="fa fa-pencil absolute {open ? 'hidden' : 'right-4 top-3.5'}" on:click={toggle} on:keypress={toggle}/> -->
    </div>

    <button
      on:keypress={removeElement}
      on:click={removeElement}
      class="flex h-4 w-4 cursor-pointer items-center justify-center rounded text-sm font-bold text-gray-500 hover:text-secondary-600"
    >
      <i class="fa-solid fa-x"></i>
    </button>
  </div>

  {#if open}
    <div class="rounded-bl-xl rounded-br-xl bg-zinc-100 p-4">
      <FontEditor target={getElement()} advanced={true} />
    </div>
  {/if}
</div>

<style lang="postcss">
  .fa.fa-pencil {
    font-size: 0.8rem;
  }
  .fa.fa-times {
    line-height: 0;
    font-size: 0.7rem;
  }
  .nolineheight {
    line-height: 0;
  }
</style>
